import React from 'react';
import {
  Box,
  Button,
  CardContent,
  MenuItem,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Tooltip
} from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { format } from 'date-fns';
import Client from '../Client';
import BackofficeReportsApi from './backofficeReportsApi';

let d = new Date();
const getISODay = d => (d.getDay() + 6) % 7 + 1;

let today = format(d, 'yyyy-MM-dd');
let yesterday = format(new Date(new Date(d).setDate(d.getDate() - 1)), 'yyyy-MM-dd');
let d1Month = format(new Date(d.getFullYear(), d.getMonth(), 1), 'yyyy-MM-dd');
let d1Year = format(new Date(d.getFullYear(), 0, 1), 'yyyy-MM-dd');
let d1Week = format(new Date(new Date(d).setDate(d.getDate() - getISODay(d) + 1)), 'yyyy-MM-dd');

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

const period = [
  {
    value: 'today',
    label: 'Today'
  },
  {
    value: 'yesterday',
    label: 'Yesterday'
  },
  {
    value: 'week',
    label: 'This Week'
  },
  {
    value: 'month',
    label: 'This Month'
  },
  {
    value: 'year',
    label: 'This Year'
  },
  {
    value: 'custom',
    label: 'Custom'
  }
];

const objectToCsv = function (data) {
  if (!data || data.length === 0) return '';

  const csvRows = [];
  const headers = Object.keys(data[0]);

  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header] === null || row[header] === undefined ? '' : row[header];
      return `"${String(val).replace(/"/g, '""')}"`;
    });

    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

class PaymentLocationList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client('none'),
      saleslocation_list: [],
      page: 0,
      rowsPerPage: -1,
      dateFrom: d1Month,
      dateTo: today,
      sx_hidden: { display: 'none' },
      value: '1',
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.addDateFrom = this.addDateFrom.bind(this);
    this.addDateTo = this.addDateTo.bind(this);
    this.selectPeriod = this.selectPeriod.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    let queryData = {
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo
    };

    let data = BackofficeReportsApi.getSalesByPaymentType(this.state.client, queryData);

    if (data) {
      this.setState({ saleslocation_list: data });
    }

    this.setState({ filterData: queryData });
  }

  doSync() {
    this.getData();
  }

  addDateFrom = event => {
    this.setState({ dateFrom: event.target.value });
  };

  addDateTo = event => {
    this.setState({ dateTo: event.target.value });
  };

  selectPeriod = event => {
    switch (event.target.value) {
      case 'today':
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState(
          { dateFrom: today },
          function () {}
        );
        this.setState(
          { dateTo: today },
          function () {
            this.doSync();
          }
        );
        break;

      case 'yesterday':
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState(
          { dateFrom: yesterday },
          function () {}
        );
        this.setState(
          { dateTo: yesterday },
          function () {
            this.doSync();
          }
        );
        break;

      case 'week':
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState(
          { dateFrom: d1Week },
          function () {}
        );
        this.setState(
          { dateTo: today },
          function () {
            this.doSync();
          }
        );
        break;

      case 'month':
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState(
          { dateFrom: d1Month },
          function () {}
        );
        this.setState(
          { dateTo: today },
          function () {
            this.doSync();
          }
        );
        break;

      case 'year':
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState(
          { dateFrom: d1Year },
          function () {}
        );
        this.setState(
          { dateTo: today },
          function () {
            this.doSync();
          }
        );
        break;

      default:
        this.setState(
          { sx_hidden: {} },
          function () {
            this.doSync();
          }
        );
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  };

  onDownload = () => {
    const link = document.createElement('a');
    link.download = 'salesHours_' + this.state.dateFrom + '-' + this.state.dateTo + '.csv';

    let csvData = objectToCsv(this.state.saleslocation_list.result);
    let csvHeader =
      'Sales value Hours\nDate From: ' +
      this.state.dateFrom +
      '\nDate To: ' +
      this.state.dateTo;

    let csv = '\uFEFF' + csvHeader + '\n' + csvData;

    link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    link.click();
  };

  render() {
    let page = this.state.page;
    let rowsPerPage = this.state.rowsPerPage;
    let locationSalesData = [];
    let locationSalesList = [];

    if (this.state.saleslocation_list) {
      if (this.state.saleslocation_list.result) {
        let counter = 0;

        Object.keys(this.state.saleslocation_list.result).forEach(key => {
          let fData = this.state.saleslocation_list.result[key];

          let myData = {
            x: fData.name,
            y: parseInt(fData.value / 1000) + 'K'
          };

          let p = {
            id: counter + 1,
            name: fData.name,
            value: thousandsSeparator(parseInt(fData.total || 0)),
            card: thousandsSeparator(parseInt(fData.card || 0)),
            cash: thousandsSeparator(parseInt(fData.cash || 0)),
            voucher: thousandsSeparator(parseInt(fData.voucher || 0)),
            credit: thousandsSeparator(parseInt(fData.credit || 0))
          };

          if (counter < 10) {
            locationSalesData.push(myData);
          }

          counter += 1;
          locationSalesList.push(p);
        });
      }
    }

    const bodyCellSx = {
      py: {
        xs: 0.55,
        sm: 0.75,
        md: 0.8
      },
      px: {
        xs: 0.35,
        sm: 0.65,
        md: 1
      },
      whiteSpace: 'nowrap',
      color: '#111827',
      fontWeight: 450,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontVariantNumeric: 'tabular-nums'
    };

    const headerCellSx = {
      py: {
        xs: 0.5,
        sm: 0.7,
        md: 0.85
      },
      px: {
        xs: 0.35,
        sm: 0.65,
        md: 1
      },
      bgcolor: '#f8fafc',
      color: '#1a237e',
      fontWeight: 650,
      lineHeight: 1.15,
      whiteSpace: 'normal',
      overflow: 'visible',
      textOverflow: 'clip'
    };

    return (
      <CardContent
        sx={{
          position: 'relative',
          width: '100%',
          height: {
            xs: 'calc(100vh - 190px)',
            sm: 'calc(100vh - 190px)',
            md: '100%'
          },
          maxHeight: {
            xs: 'calc(100vh - 190px)',
            sm: 'calc(100vh - 190px)',
            md: '100%'
          },
          minHeight: 0,
          p: '0 !important',
          borderRadius: {
            xs: '14px',
            sm: '16px'
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          bgcolor: '#fff'
        }}
      >
        <Box
          sx={{
            px: {
              xs: 0.75,
              sm: 1,
              md: 1.25
            },
            py: {
              xs: 0.65,
              sm: 0.75
            },
            flexShrink: 0,
            borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
            background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)'
          }}
        >
          {/* Row 1: title + download */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
              mb: 0.75
            }}
          >
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Typography
                sx={{
                  color: '#1a237e',
                  fontWeight: 800,
                  fontSize: {
                    xs: '0.9rem',
                    sm: '1rem',
                    md: '1.05rem'
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                Payments by Location
              </Typography>

              <Typography
                sx={{
                  mt: 0.15,
                  color: '#64748b',
                  fontWeight: 600,
                  fontSize: {
                    xs: '0.72rem',
                    sm: '0.78rem'
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                Payment split by method
              </Typography>
            </Box>

            <Tooltip title="Download CSV">
              <Button
                size="small"
                onClick={this.onDownload}
                variant="contained"
                sx={{
                  minWidth: 36,
                  width: 36,
                  height: 36,
                  p: 0,
                  flexShrink: 0,
                  borderRadius: '12px',
                  color: '#1a237e',
                  bgcolor: 'rgba(26, 35, 126, 0.08)',
                  boxShadow: 'none',
                  border: '1px solid rgba(26, 35, 126, 0.12)',
                  '&:hover': {
                    bgcolor: 'rgba(26, 35, 126, 0.12)',
                    boxShadow: 'none'
                  }
                }}
              >
                <FileDownloadIcon fontSize="small" />
              </Button>
            </Tooltip>
          </Box>

          {/* Row 2: filters */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: {
                xs: 'flex-start',
                md: 'flex-end'
              },
              gap: 0.75,
              flexWrap: {
                xs: 'wrap',
                sm: 'nowrap'
              },
              minWidth: 0
            }}
          >
            <TextField
              id="standard-select-period"
              select
              defaultValue="month"
              size="small"
              onChange={this.selectPeriod}
              sx={{
                width: {
                  xs: 138,
                  sm: 150
                },
                flexShrink: 0,
                '& .MuiInputBase-root': {
                  height: 34,
                  borderRadius: '12px',
                  fontSize: {
                    xs: '0.82rem',
                    sm: '0.88rem'
                  },
                  bgcolor: '#fff'
                }
              }}
            >
              {period.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>

            <Box
              sx={{
                ...this.state.sx_hidden,
                alignItems: 'center',
                gap: 0.75,
                flexWrap: {
                  xs: 'wrap',
                  sm: 'nowrap'
                },
                minWidth: 0
              }}
            >
              <TextField
                size="small"
                id="dateFrom"
                label="From"
                type="date"
                value={this.state.dateFrom}
                sx={{
                  width: {
                    xs: 128,
                    sm: 132
                  },
                  flexShrink: 0,
                  '& .MuiInputBase-root': {
                    height: 34,
                    borderRadius: '12px',
                    fontSize: '0.82rem'
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  sx: { color: '#5b5b5b' }
                }}
                InputProps={{
                  sx: { color: '#5b5b5b' }
                }}
                inputProps={{
                  min: '2024-01-01',
                  style: {
                    color: '#5b5b5b',
                    paddingRight: 5,
                    paddingLeft: 5
                  }
                }}
                onChange={this.addDateFrom}
              />

              <TextField
                size="small"
                id="dateTo"
                label="To"
                type="date"
                value={this.state.dateTo}
                sx={{
                  width: {
                    xs: 128,
                    sm: 132
                  },
                  flexShrink: 0,
                  '& .MuiInputBase-root': {
                    height: 34,
                    borderRadius: '12px',
                    fontSize: '0.82rem'
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  sx: { color: '#5b5b5b' }
                }}
                InputProps={{
                  sx: { color: '#5b5b5b' }
                }}
                inputProps={{
                  min: '2024-01-01',
                  style: {
                    color: '#5b5b5b',
                    paddingRight: 5,
                    paddingLeft: 5
                  }
                }}
                onChange={this.addDateTo}
              />

              <Tooltip title="Refresh">
                <Button
                  size="small"
                  onClick={() => this.doSync()}
                  variant="contained"
                  sx={{
                    minWidth: 34,
                    width: 34,
                    height: 34,
                    p: 0,
                    flexShrink: 0,
                    borderRadius: '12px',
                    color: '#1a237e',
                    bgcolor: 'rgba(26, 35, 126, 0.08)',
                    boxShadow: 'none',
                    border: '1px solid rgba(26, 35, 126, 0.12)',
                    '&:hover': {
                      bgcolor: 'rgba(26, 35, 126, 0.12)',
                      boxShadow: 'none'
                    }
                  }}
                >
                  <AutorenewIcon fontSize="small" />
                </Button>
              </Tooltip>
            </Box>
          </Box>
        </Box>

        <TableContainer
          sx={{
            flex: 1,
            minHeight: 0,
            overflowX: 'auto',
            overflowY: locationSalesList.length > 10 ? 'auto' : 'hidden',
            width: '100%',
            '& .MuiTableCell-root': {
              borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
              fontSize: {
                xs: '0.78rem',
                sm: '0.88rem',
                md: '0.92rem'
              }
            },
            '& .MuiTableRow-hover:hover': {
              backgroundColor: 'rgba(26, 35, 126, 0.035)'
            }
          }}
        >
          <Table
            stickyHeader
            size="small"
            aria-label="payment location table"
            sx={{
              minWidth: {
                xs: 640,
                sm: 760,
                md: '100%'
              },
              width: '100%',
              tableLayout: {
                xs: 'fixed',
                md: 'auto'
              }
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    ...headerCellSx,
                    position: 'sticky',
                    left: 0,
                    zIndex: 4,
                    width: {
                      xs: 130,
                      sm: 180,
                      md: '26%'
                    }
                  }}
                >
                  Name
                </TableCell>

                {[
                  ['Total', { xs: 92, sm: 110, md: '15%' }],
                  ['Card', { xs: 86, sm: 105, md: '15%' }],
                  ['Cash', { xs: 86, sm: 105, md: '15%' }],
                  ['Voucher', { xs: 92, sm: 110, md: '15%' }],
                  ['Credit', { xs: 82, sm: 100, md: '14%' }]
                ].map(([label, width]) => (
                  <TableCell
                    key={label}
                    align="right"
                    sx={{
                      ...headerCellSx,
                      width
                    }}
                  >
                    {label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? locationSalesList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : locationSalesList
              ).map(location => {
                return (
                  <TableRow hover key={location.id} tabIndex={-1}>
                    <TableCell
                      sx={{
                        py: {
                          xs: 0.55,
                          sm: 0.75,
                          md: 0.8
                        },
                        px: {
                          xs: 0.35,
                          sm: 0.65,
                          md: 1
                        },
                        position: 'sticky',
                        left: 0,
                        zIndex: 2,
                        bgcolor: '#fff',
                        whiteSpace: 'nowrap',
                        color: '#111827',
                        fontWeight: 550,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: {
                          xs: 130,
                          sm: 180,
                          md: '26%'
                        }
                      }}
                    >
                      {location.name}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {location.value}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {location.card}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {location.cash}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {location.voucher}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {location.credit}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, { value: -1, label: 'All' }]}
          labelRowsPerPage="Rows:"
          component="div"
          count={locationSalesList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          sx={{
            flexShrink: 0,
            borderTop: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: '#fff',
            minHeight: {
              xs: 44,
              sm: 52
            },
            overflow: 'hidden',
            '& .MuiTablePagination-toolbar': {
              minHeight: {
                xs: 44,
                sm: 52
              },
              px: {
                xs: 0.5,
                sm: 1
              },
              flexWrap: {
                xs: 'wrap',
                sm: 'nowrap'
              },
              gap: {
                xs: 0.25,
                sm: 0.5
              }
            },
            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
              fontSize: {
                xs: '0.88rem',
                sm: '0.92rem',
                md: '1rem'
              },
              m: 0
            },
            '& .MuiTablePagination-actions': {
              ml: {
                xs: 0,
                sm: 1
              }
            }
          }}
        />
      </CardContent>
    );
  }
}

export default PaymentLocationList;
